export class TabsDropdown {
    private heads: NodeListOf<HTMLElement>;
    private breakpoint = 991;

    constructor() {
        this.heads = document.querySelectorAll<HTMLElement>('.tabs-head');
        this.init();
    }

    private init() {
        this.heads.forEach(head => {
            const toggleBtn = head.querySelector<HTMLButtonElement>('.tabs-default');
            const defaultText = toggleBtn?.querySelector<HTMLElement>('.production-tabs-default-text');
            const dropdownBtns = head.querySelectorAll<HTMLButtonElement>('.tabs-dropdown .tab-btn');

            if (!toggleBtn || !defaultText) return;

            // Клик по кнопке toggle
            toggleBtn.addEventListener('click', (e) => {
                e.stopPropagation();
                if (window.innerWidth < this.breakpoint) {
                    head.classList.toggle('active');
                }
            });

            // Клик по кнопке внутри дропдауна
            dropdownBtns.forEach(btn => {
                btn.addEventListener('click', () => {
                    if (window.innerWidth < this.breakpoint) {
                        head.classList.remove('active');

                        // Обновляем текст кнопки toggle
                        defaultText.textContent = btn.textContent?.trim() || '';
                    }
                });
            });
        });

        // Клик вне .tabs-head закрывает все дропдауны
        document.addEventListener('click', (e) => {
            if (window.innerWidth >= this.breakpoint) return;

            this.heads.forEach(head => {
                if (!head.contains(e.target as Node)) {
                    head.classList.remove('active');
                }
            });
        });

        // Закрытие при ресайзе экрана
        window.addEventListener('resize', () => {
            if (window.innerWidth >= this.breakpoint) {
                this.heads.forEach(head => head.classList.remove('active'));
            }
        });
    }
}
